import {
  Heading,
  HStack,
  Text,
  VStack,
} from '@ayble-health/dashboard-components';
import { Badge, Box } from '@chakra-ui/react';
import TrendingIconUpSVG from '../CustomSVGs/TrendingIconUpSVG';
import { PropsWithChildren } from 'react';
import TrendingIconDownSVG from '../CustomSVGs/TrendingIconDownSVG';
import { Trend } from '../../models/score';

type Props = {
  circleStyle: 'solid' | 'outline';
  badgeColor: string;
  badgeStyle: 'solid' | 'outline';
  badgeText?: string;
  title: string;
  trend: Trend;
  value?: number;
};

export const PanelWidget = ({
  badgeColor,
  badgeStyle,
  badgeText,
  children,
  circleStyle,
  title,
  trend,
  value,
}: PropsWithChildren<Props>) => {
  const TrendIcon =
    trend === Trend.up ? TrendingIconUpSVG : TrendingIconDownSVG;

  return (
    <VStack
      borderColor={'cloud.200'}
      borderWidth={1}
      minH={'116px'}
      justifyContent={'space-around'}
      p={2}
      rounded={'lg'}
      w={'117px'}
    >
      <Text color={'secondary.500'} fontSize={'xs'} fontWeight={'normal'}>
        <Box
          bgColor={circleStyle === 'solid' ? badgeColor : undefined}
          borderWidth={1}
          borderColor={badgeColor}
          h={'9px'}
          mt={0.5}
          mr={1}
          rounded={'full'}
          w={'9px'}
        />

        {title}
      </Text>

      {badgeText && (
        <Badge
          bgColor={badgeStyle === 'solid' ? badgeColor : 'transparent'}
          borderColor={badgeColor}
          color={badgeStyle === 'solid' ? 'white' : 'secondary.600'}
          fontSize={'7px'}
          height={'16px'}
          my={2}
          rounded={'full'}
          variant={badgeStyle}
          width={'75px'}
        >
          {badgeText}
        </Badge>
      )}

      <HStack alignItems={'center'}>
        <TrendIcon height={8} width={8} />

        <Heading color={'secondary.500'} fontSize={'2xl'} ml={2}>
          {value ?? '--'}
        </Heading>
      </HStack>

      {children}
    </VStack>
  );
};
